import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CostAccountingTypeDialogModule } from './cost-accounting-type-dialog/cost-accounting-type-dialog.module';
import { CostAccountingTypePage } from './cost-accounting-type.page';
import { MatTooltipModule } from '@angular/material/tooltip';


export * from './cost-accounting-type.page';
export * from './cost-accounting-type-dialog/cost-accounting-type-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: CostAccountingTypePage,
    },
];

@NgModule({
    declarations: [ CostAccountingTypePage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatTableModule,
        TranslateModule,
        MatPaginatorModule,
        CostAccountingTypeDialogModule,
        MatTooltipModule
    ],
})
export class CostAccountingTypePageModule {

}
